/**
 * TanStack Query hooks for `pre-landing-page-support`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	preLandingPageSupportQueryKeys,
	type CreatePreLandingPageSupportBody,
	type ListPreLandingPageSupportResponse,
	type PreLandingPageSupportRow,
} from "./api";

export function usePreLandingPageSupportList(): UseQueryResult<ListPreLandingPageSupportResponse, Error> {
	return useQuery({
		queryKey: preLandingPageSupportQueryKeys.list(),
		queryFn: list,
	});
}

export function usePreLandingPageSupportCreate(): UseMutationResult<PreLandingPageSupportRow, Error, CreatePreLandingPageSupportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: preLandingPageSupportQueryKeys.all });
		},
	});
}

export function usePreLandingPageSupportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: preLandingPageSupportQueryKeys.all });
		},
	});
}
